import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

/**
 * Shared layout for public policy pages (Contact, Terms, Refund, Privacy).
 * Kept intentionally sparse — Cashfree, RBI advisories, and search engines
 * expect these to look plain and readable, not marketing pages.
 */
export const LegalPageLayout = ({ title, lastUpdated, children }) => (
  <div className="min-h-screen bg-white" data-testid="legal-page">
    <Header />
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
      <nav className="text-xs text-slate-500 mb-6" aria-label="Breadcrumb">
        <Link to="/" className="hover:text-[#0A2540]" data-testid="legal-breadcrumb-home">Home</Link>
        <span className="mx-2">/</span>
        <span className="text-slate-700">{title}</span>
      </nav>
      <h1
        className="text-3xl sm:text-4xl font-extrabold text-[#0A2540] tracking-tight"
        style={{ fontFamily: "Poppins" }}
        data-testid="legal-page-title"
      >
        {title}
      </h1>
      {lastUpdated ? (
        <p className="mt-2 text-sm text-slate-500" data-testid="legal-last-updated">
          Last updated: {lastUpdated}
        </p>
      ) : null}
      <div
        className="legal-content mt-8 text-slate-700 leading-relaxed"
        data-testid="legal-content"
      >
        {children}
      </div>
      <style>{`
        .legal-content h2 {
          color: #0A2540;
          font-weight: 700;
          font-size: 1.25rem;
          line-height: 1.4;
          margin-top: 2.25rem;
          margin-bottom: 0.75rem;
          font-family: Poppins, ui-sans-serif, system-ui;
        }
        .legal-content h3 {
          color: #0A2540;
          font-weight: 600;
          font-size: 1.0625rem;
          line-height: 1.4;
          margin-top: 1.5rem;
          margin-bottom: 0.5rem;
        }
        .legal-content p { margin: 0.75rem 0; }
        .legal-content ul, .legal-content ol { margin: 0.75rem 0; padding-left: 1.5rem; }
        .legal-content li { margin: 0.35rem 0; list-style-position: outside; }
        .legal-content ul li { list-style-type: disc; }
        .legal-content ol li { list-style-type: decimal; }
        .legal-content a { color: #0A2540; text-decoration: underline; }
        .legal-content a:hover { color: #D4AF37; }
        .legal-content strong { color: #0A2540; }
      `}</style>
    </main>
    <Footer />
  </div>
);

export default LegalPageLayout;
